import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, FormGroup, Input, Label, Row} from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';
import { getCurrencySymbol, transformProductPrice } from '../../../../../utils/CommonUtils';
import RecurringModal from './RecurringModal';
import { getSubscription, loadOrderTypes, saveSubscription } from '../../../../../actions';
import moment from 'moment';

class Subscription extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fixedPriceRate: {
                fixedPriceRateAmount: null,
                fixedPriceRateDate: null,
                subscriptionNote: ''
            },
            fixedPricePerOrder: {
                fixedPricePerOrderAmount: null,
                fixedPricePerOrderDate: null,
                subscriptionNote: ''
            },
            percentFromOrderTotal: {
                percentFromOrderTotalAmount: null,
                percentFromOrderTotalDate: null,
                subscriptionNote: ''
            },
            recurringCharges: [],
            currentRecurringCharge: {
                name: '',
                description: '',
                percentage: false,
                amount: null,
                orderType: {
                    id: -1,
                    value: 'Select type'
                },
                paymentType: { 
                    id: -1,
                    value: 'Select type'
                },
                createDate: null
            },
            taxPercent: null,
            isRecurringModalOpen: false,
            recurringChargeIndex: -1,
            toSave: false,
            toSaveReccuringCharges: false,
            smsFee: null
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.applyCurrentRecurringCharge = this.applyCurrentRecurringCharge.bind(this);
    }

    componentDidMount() {
       
        this.props.loadOrderTypes();
        this.props.getSubscription(this.props.match.params.id);
        
    }

    componentDidUpdate(prevProps) {
        
        const { subscription } = this.props.restaurant;
        
        if(subscription !== prevProps.restaurant.subscription) {
            this.setState({
            fixedPriceRate: {
                fixedPriceRateAmount: subscription.fixedPriceSubscription ? transformProductPrice(Number(subscription.fixedPriceSubscription.amount)) : null,
                fixedPriceRateDate: subscription.fixedPriceSubscription ? subscription.fixedPriceSubscription.startTime : null,
                subscriptionNote: subscription.fixedPriceSubscription ? subscription.fixedPriceSubscription.note : ''
            },
            fixedPricePerOrder: {
                fixedPricePerOrderAmount: subscription.pricePerOrderSubscription ? transformProductPrice(Number(subscription.pricePerOrderSubscription.amount)) : null,
                fixedPricePerOrderDate: subscription.pricePerOrderSubscription ? subscription.pricePerOrderSubscription.startTime : null,
                subscriptionNote: subscription.pricePerOrderSubscription ? subscription.pricePerOrderSubscription.note : ''
            },
            percentFromOrderTotal: {
                percentFromOrderTotalAmount: subscription.percentPerOrderSubscription ? subscription.percentPerOrderSubscription.amount : null,
                percentFromOrderTotalDate: subscription.percentPerOrderSubscription ? subscription.percentPerOrderSubscription.startTime : null,
                subscriptionNote: subscription.percentPerOrderSubscription ? subscription.percentPerOrderSubscription.note : ''
            },
            recurringCharges: subscription.recurringCharges,
            taxPercent: subscription.taxPercent || subscription.taxPercent === 0 ? subscription.taxPercent : null,
            toSave: false,
            toReset: false,
            smsFee: transformProductPrice(subscription.smsFee)
            })

            document.getElementById("fixedPriceRateDate").value = subscription.fixedPriceSubscription ? moment(subscription.fixedPriceSubscription.startTime, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            document.getElementById("fixedPricePerOrderDate").value = subscription.pricePerOrderSubscription ? moment(subscription.pricePerOrderSubscription.startTime, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            document.getElementById("percentFromOrderTotalDate").value = subscription.percentPerOrderSubscription ? moment(subscription.percentPerOrderSubscription.startTime, 'DD-MM-YYYY').format('YYYY-MM-DD') : '';
        }
    }

    toggleModal(recurringCharge, recurringChargeIndex) {

        this.setState({
            ...this.state,
            isRecurringModalOpen: !this.state.isRecurringModalOpen,
            currentRecurringCharge: recurringCharge ? recurringCharge : {},
            recurringChargeIndex: recurringChargeIndex >= 0 ? recurringChargeIndex : -1
        })
    }

    renderSaveReminder(isAddButtonReminder) {
        const { reminderText } = styles;
        return (
            <p style={isAddButtonReminder ? {...reminderText, right: '30px', top: '52px'} : reminderText}>{i18n.t('common:validations.saveWarningMsg')}</p>
        );
    }

    changeState = ({ target }) => {
        let targetValue = target.value;
        const time = '00:00:00';

        if (target.type === 'date') {
            targetValue = target.value.split(/\D/);
            targetValue = new Date(targetValue[0], --targetValue[1], targetValue[2]);
            targetValue = moment(targetValue).format("DD-MM-YYYY")

            this.setState({
                ...this.state,
                toSave: true
            })
        }

        if (target.name === 'fixedPriceRateAmount') {
            this.setState({
                ...this.state,
                fixedPriceRate: {
                    ...this.state.fixedPriceRate,
                    fixedPriceRateAmount: targetValue
                },
                toSave: true
            });
        } else if (target.name === 'fixedPriceRateDate') {
            this.setState({
                ...this.state,
                fixedPriceRate: {
                    ...this.state.fixedPriceRate,
                    fixedPriceRateDate: `${targetValue} ${time}`
                },
                toSave: true
            });
        } else if (target.name === 'fixedPriceRateNote') {
            this.setState({
                ...this.state,
                fixedPriceRate: {
                    ...this.state.fixedPriceRate,
                    subscriptionNote: targetValue
                },
                toSave: true
            });

        } else if (target.name === 'fixedPricePerOrderAmount') {
            this.setState({
                ...this.state,
                fixedPricePerOrder: {
                    ...this.state.fixedPricePerOrder,
                    fixedPricePerOrderAmount: targetValue
                },
                toSave: true
            });
        } else if (target.name === 'fixedPricePerOrderDate') {
            this.setState({
                ...this.state,
                fixedPricePerOrder: {
                    ...this.state.fixedPricePerOrder,
                    fixedPricePerOrderDate: `${targetValue} ${time}`
                },
                toSave: true
            });
        } else if (target.name === 'fixedPricePerOrderNote') {
            this.setState({
                ...this.state,
                fixedPricePerOrder: {
                    ...this.state.fixedPricePerOrder,
                    subscriptionNote: targetValue
                },
                toSave: true
            });

        } else if (target.name === 'percentFromOrderTotalAmount') {
            this.setState({
                ...this.state,
                percentFromOrderTotal: {
                    ...this.state.percentFromOrderTotal,
                    percentFromOrderTotalAmount: targetValue
                },
                toSave: true
            });
        } else if (target.name === 'percentFromOrderTotalDate') {
            this.setState({
                ...this.state,
                percentFromOrderTotal: {
                    ...this.state.percentFromOrderTotal,
                    percentFromOrderTotalDate: `${targetValue} ${time}`
                },
                toSave: true
            });
        }  else if (target.name === 'percentFromOrderTotalAmountNote') {
            this.setState({
                ...this.state,
                percentFromOrderTotal: {
                    ...this.state.percentFromOrderTotal,
                    subscriptionNote: targetValue
                },
                toSave: true
            });

        } else if (target.name === 'taxPercent') {
            this.setState({
                ...this.state,
                [target.name]: targetValue,
                toSave: true
            });
        } else if (target.name === 'smsFee') {
            this.setState({
                ...this.state,
                [target.name]: targetValue,
                toSave: true
            });
        } else {
            this.setState({
                ...this.state,
                [target.name]: targetValue
            });
        }
    }

    applyCurrentRecurringCharge(currentRecurringCharge, removeCurrentRecurringCharge) {

        let copyOfRecurringCharges = this.state.recurringCharges ? this.state.recurringCharges : [];
        let modifiedCurrentReccuringCharge = currentRecurringCharge

        if (modifiedCurrentReccuringCharge.orderType) {
            if (modifiedCurrentReccuringCharge.orderType.id === -1) {
                modifiedCurrentReccuringCharge.orderType = null;
            }
        }
       
        if (modifiedCurrentReccuringCharge.paymentType) {
            if (modifiedCurrentReccuringCharge.paymentType.id === -1) {
                modifiedCurrentReccuringCharge.paymentType = null;
            }
        }

        if (this.state.recurringChargeIndex >= 0 && !removeCurrentRecurringCharge) {

            copyOfRecurringCharges.map((recurringCharge, index) => {

                if (index === this.state.recurringChargeIndex) {
                    copyOfRecurringCharges.splice(index, 1, modifiedCurrentReccuringCharge);
                }
            });
        } else if (removeCurrentRecurringCharge) {
            copyOfRecurringCharges.map((recurringCharge, index) => {
                if (index === this.state.recurringChargeIndex) {
                    copyOfRecurringCharges.splice(index, 1);
                }
            });
        } else {
            
            copyOfRecurringCharges.push(modifiedCurrentReccuringCharge);
        }

        this.setState({
            ...this.state,
            recurringCharges: copyOfRecurringCharges,
            isRecurringModalOpen: false,
            recurringChargeIndex: -1,
            toSaveReccuringCharges: true 
        });
    }

    transformToLocalize(value) { // Transforms item.value so it can be translated.
    
        switch (value) {
            case "Collection":
                return i18n.t('screens:restaurantsMainContainer.collection');
            case "Delivery":
                return i18n.t('screens:restaurantsMainContainer.delivery');
            case "Curbside":
                return i18n.t('screens:restaurantsMainContainer.curbside');
            case "In Store":
                return i18n.t('screens:restaurantsMainContainer.instore');
            case "Dine In":
                return i18n.t('screens:restaurantsMainContainer.dinein')
            default:
                return;
        }
    }

    transformToLocalizeTenderTypes (value) {
        
        switch (value) {
            case "Credit card":
                return i18n.t(`common:paymentTypes.creditCard`);
            case "Cash":
                return i18n.t(`common:paymentTypes.cash`);
            default:
                return;
        }
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    onClear(state) {
        
        if(state === 'fixedPriceRate') {
            this.setState({
                ...this.state,
                fixedPriceRate: {
                    fixedPriceRateAmount: null,
                    fixedPriceRateDate: null,
                    subscriptionNote: ''
                },
                toSave: true
            },
            () => {
                document.getElementById("fixedPriceRateDate").value = '';
            });
            
        }

        if(state === 'fixedPricePerOrder') {
            this.setState({
                ...this.state,
                fixedPricePerOrder: {
                    fixedPricePerOrderAmount: null,
                    fixedPricePerOrderDate: null,
                    subscriptionNote: ''
                },
                toSave: true
            },
            () => {
                document.getElementById("fixedPricePerOrderDate").value = '';
            })
        }

        if(state === 'percentFromOrderTotal') {
            this.setState({
                ...this.state,
                percentFromOrderTotal: {
                    percentFromOrderTotalAmount: null,
                    percentFromOrderTotalDate: null,
                    subscriptionNote: ''
                },
                toSave: true
            },
            () => {
                document.getElementById("percentFromOrderTotalDate").value = '';
            })
        }
    }

    onSaveSubscription() {
        
        this.props.saveSubscription(this.state, () => {
            this.props.getSubscription(this.props.match.params.id);
            this.setState({
                ...this.state,
                toSave: false,
                toSaveReccuringCharges: false
            })
        });
    }

    renderHeader() {
        const { headerStyle, spaceBetween } = this.props.styles;

        return (
            <div style={headerStyle}>
                <MaterialIcon icon="attach_money" color="#0288d1" size={20} />
                <span style={spaceBetween}>{i18n.t('screens:paymentScreen.subscription')}</span>
            </div>
        );
    }

    getSubscriptionNote(subscriptionInputType) {
        let note = '';

        switch (subscriptionInputType) {
            case 'fixedPriceRateNote':
                return note = this.state.fixedPriceRate.subscriptionNote;
            case 'fixedPricePerOrderNote':
                return note = this.state.fixedPricePerOrder.subscriptionNote;
            case 'percentFromOrderTotalAmountNote':
                return note = this.state.percentFromOrderTotal.subscriptionNote;
            default:
                return '';
        }
    }

    renderFixedPriceRate() {
        const { cardContainer, btnStyle } = styles;
        const { fixedPriceRateAmount } = this.state.fixedPriceRate
       
        return (
            <div>
                <Row xs={12} style={cardContainer}>
                    <Col xs={4}>
                        <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '0px', alignItems: 'center', justifyContent: 'space-between'}}>
                            <Label xs={6}>{i18n.t('screens:paymentScreen.fixedPriceRate')}</Label>
                            <Col xs={6} style={{display: 'flex', paddingLeft: '0px', marginLeft: '7px'}}>
                                <Input 
                                    type="number" 
                                    name="fixedPriceRateAmount"
                                    min={0}
                                    value={fixedPriceRateAmount ? fixedPriceRateAmount : ''}
                                    onChange={this.changeState}
                                    onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                    disabled={this.props.isMenuuAdmin}
                                />
                            <div style={{ display: 'flex', padding: '9px 0 0 5px' }}>{getCurrencySymbol(this.props.restaurant.currency)}</div>
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col xs={4}>
                        <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '0px', alignItems: 'center', justifyContent: 'space-between'}}>
                            <Label xs={6}>{i18n.t('screens:paymentScreen.startFrom')}</Label>
                            <Col xs={6} style={{display: 'flex', paddingLeft: '0px'}}>
                                <Input 
                                    id="fixedPriceRateDate"
                                    type="date" 
                                    name="fixedPriceRateDate"
                                    onChange={this.changeState}
                                    disabled={this.props.isMenuuAdmin}
                                />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col xs={3} style={{display: 'flex', flexDirection: 'column'}}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <p style={{marginRight: '10px', marginBottom: '0px'}}>{i18n.t('screens:paymentScreen.period')}:</p>
                            <p style={{marginBottom: '0px'}}>{i18n.t('screens:paymentScreen.monthly')}</p>
                        </div>
                    </Col>
                    <Col xs={1} style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Button disabled={this.props.isMenuuAdmin} color="primary" onClick={() => this.onClear('fixedPriceRate')}>
                            <span style={btnStyle}>{i18n.t('common:buttons.reset')}</span>
                        </Button>
                    </Col>
                </Row>
                {this.renderSubscriptionNote('fixedPriceRateNote')}
            </div>
        )
    }

    renderFixedPricePerOrder() {
        const { cardContainer, btnStyle } = styles;
        const { fixedPricePerOrderAmount } = this.state.fixedPricePerOrder;
        
        return (
            <div>
                <Row xs={12} style={cardContainer}>
                    <Col xs={4}>
                        <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '0px', alignItems: 'center', justifyContent: 'space-between'}}>
                            <Label xs={6}>{i18n.t('screens:paymentScreen.fixedPricePerOrder')}</Label>
                            <Col xs={6} style={{display: 'flex', paddingLeft: '0px', marginLeft: '7px'}}>
                                <Input type="number" name="fixedPricePerOrderAmount"
                                    min={0}
                                    value={fixedPricePerOrderAmount ? fixedPricePerOrderAmount : ''}
                                    onChange={this.changeState}
                                    onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                    disabled={this.props.isMenuuAdmin}
                                />
                            <div style={{ display: 'flex', padding: '9px 0 0 5px' }}>{getCurrencySymbol(this.props.restaurant.currency)}</div>
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col xs={4}>
                        <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '0px', alignItems: 'center', justifyContent: 'space-between'}}>
                            <Label xs={6}>{i18n.t('screens:paymentScreen.startFrom')}</Label>
                            <Col xs={6} style={{display: 'flex', paddingLeft: '0px'}}>
                                <Input 
                                    id="fixedPricePerOrderDate"
                                    type="date" 
                                    name="fixedPricePerOrderDate"
                                    onChange={this.changeState}
                                    disabled={this.props.isMenuuAdmin}
                                />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col xs={3} style={{display: 'flex', flexDirection: 'column'}}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <p style={{marginRight: '10px', marginBottom: '0px'}}>{i18n.t('screens:paymentScreen.period')}:</p>
                            <p style={{marginBottom: '0px'}}>{i18n.t('screens:paymentScreen.weekly')}</p>
                        </div>
                    </Col>
                    <Col xs={1} style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Button disabled={this.props.isMenuuAdmin} color="primary" onClick={() => this.onClear('fixedPricePerOrder')}>
                            <span style={btnStyle}>{i18n.t('common:buttons.reset')}</span>
                        </Button>
                    </Col>
                </Row>
                {this.renderSubscriptionNote('fixedPricePerOrderNote')}
            </div>
        )
    }

    renderPercentFromOrderTotal() {
        const { cardContainer, btnStyle } = styles;
        const { percentFromOrderTotalAmount } = this.state.percentFromOrderTotal;

        return (
            <div>
                <Row xs={12} style={cardContainer}>
                    <Col xs={4}>
                        <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '0px', alignItems: 'center'}}>
                            <Label xs={6} >{i18n.t('screens:paymentScreen.percentFromOrderTotal')}</Label>
                            <Col xs={6} style={{display: 'flex', paddingLeft: '0px', marginLeft: '7px'}}>
                                <Input type="number" name="percentFromOrderTotalAmount"
                                    style={{height: '46px'}}
                                    min={0}
                                    value={percentFromOrderTotalAmount ? percentFromOrderTotalAmount : ''}
                                    onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                    onChange={this.changeState}
                                    disabled={this.props.isMenuuAdmin}
                                />
                                
                            <div style={{ display: 'flex', padding: '9px 0 0 5px' }}>%</div>
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col xs={4}>
                        <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '0px', alignItems: 'center', justifyContent: 'space-between'}}>
                            <Label xs={6}>{i18n.t('screens:paymentScreen.startFrom')}</Label>
                            <Col xs={6} style={{display: 'flex', paddingLeft: '0px'}}>
                                <Input 
                                    id="percentFromOrderTotalDate"
                                    type="date" 
                                    name="percentFromOrderTotalDate"
                                    onChange={this.changeState}
                                    disabled={this.props.isMenuuAdmin}
                                />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col xs={3} style={{display: 'flex', flexDirection: 'column'}}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <p style={{marginRight: '10px', marginBottom: '0px'}}>{i18n.t('screens:paymentScreen.period')}:</p>
                            <p style={{marginBottom: '0px'}}>{i18n.t('screens:paymentScreen.weekly')}</p>
                        </div>
                    </Col>
                    <Col xs={1} style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Button disabled={this.props.isMenuuAdmin} color="primary" onClick={() => this.onClear('percentFromOrderTotal')}>
                            <span style={btnStyle}>{i18n.t('common:buttons.reset')}</span>
                        </Button>
                        {/* {this.state.toSave ? this.renderSaveReminder() : null} */}
                    </Col>
                </Row>
                {this.renderSubscriptionNote('percentFromOrderTotalAmountNote')}
            </div>
        )
    }


    renderSubscriptionNote(subscriptionInputType) {
        const { cardContainerNotes } = styles;

        return (
            <Row xs={8} style={cardContainerNotes}>
                 <Col xs={8}>
                    <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '0px', alignItems: 'center'}}>
                        <Label sm={3}>{i18n.t('screens:paymentScreen.subscriptionNotes')}</Label>
                        <Col sm={9} style={{display: 'flex', paddingLeft: '0px'}}>
                        <Input 
                            style={{ width: '100%', height: 80, resize: 'none' }}
                            type="textarea" 
                            name={subscriptionInputType} 
                            placeholder={i18n.t('screens:paymentScreen.subscriptionNotesPlaceholder')}
                            value={this.getSubscriptionNote(subscriptionInputType)}
                            onChange={this.changeState}
                            maxLength = {128}
                            disabled={this.props.isMenuuAdmin}
                        />  
                        </Col>
                    </FormGroup>
                </Col>
            </Row>
        );
    }

    renderSmsFee() {
        const { cardContainer } = styles;
        const { smsFee } = this.state;

        return (
            <div > 
                <Row xs={3} style={ cardContainer }>
                    <Col xs={4}>
                        <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '0px', alignItems: 'center'}}>
                            <Label xs={6}>{i18n.t('screens:paymentScreen.smsFee')}</Label>
                            <Col xs={6} style={{display: 'flex', paddingLeft: '0px', marginLeft: '7px'}}>
                                <Input
                                    type="number" 
                                    name="smsFee"
                                    value={smsFee}
                                    onChange={this.changeState}
                                    onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                    disabled={this.props.isMenuuAdmin}
                                />
                            <div style={{ display: 'flex', padding: '9px 0 0 5px' }}>{getCurrencySymbol(this.props.restaurant.currency)}</div>
                            </Col>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        );
    }

    renderTaxPercent() {
        const { cardContainer } = styles;
        const { taxPercent } = this.state;
        
        return (
            <div > 
            <Row xs={3} style={ cardContainer }>
                 <Col xs={4}>
                    <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '0px', alignItems: 'center'}}>
                        <Label xs={6}>{i18n.t('screens:paymentScreen.taxPercent')}</Label>
                        <Col xs={6} style={{display: 'flex', paddingLeft: '0px', marginLeft: '7px'}}>
                            <Input
                                type="number" 
                                name="taxPercent"
                                value={taxPercent === 0 || taxPercent ? taxPercent : ''}
                                onChange={this.changeState}
                                onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                disabled={this.props.isMenuuAdmin}
                            />
                        <div style={{ display: 'flex', padding: '9px 0 0 5px' }}>%</div>
                        </Col>
                    </FormGroup>
                </Col>
                <Col xs={1} style={{display: 'flex', justifyContent: 'flex-end'}}>
                    {this.state.toSave ? this.renderSaveReminder() : null}
                </Col>
            </Row>
            </div>
            
        )
    }

    renderEditButton(currentRecurringCharge, recurringChargeIndex) {
        
        return (
            <Button disabled={this.props.isMenuuAdmin} onClick={() => this.toggleModal(currentRecurringCharge, recurringChargeIndex)} color="link" style={{ padding: '0px', fontSize: '16px', height: 'auto'}}>
                {i18n.t('common:buttons.edit')}
            </Button>
        )
    }

    renderPercentCheckbox(isChecked) {

        return (
                <Input
                    style={{marginLeft: '-5px'}}
                    type='checkbox' 
                    name='percent' 
                    id='percent'
                    checked={isChecked}
                />
        )
    }

    renderOrderTypeField(fieldValue) {
        if(fieldValue === 'Select Type') {
            return i18n.t('screens:paymentScreen.all')
        } else {
            return this.transformToLocalize(fieldValue)
        }
    }

    renderTenderTypeField(fieldValue) {
        if(fieldValue === 'Select Type') {
            return i18n.t('screens:paymentScreen.all')
        } else {
            return this.transformToLocalizeTenderTypes(fieldValue)
        }
    }

    renderRecurringChargesFormRows() {
        const { recurringCharges } = this.state;
        return recurringCharges ? recurringCharges.map((recurringCharge, recurringChargeIndex) => {
            const orderTypeValue = recurringCharge.orderType ? recurringCharge.orderType.value : 'Select Type';
            const paymentTypeValue = recurringCharge.paymentType ? recurringCharge.paymentType.value : 'Select Type';     
            return (
                <Row key={recurringChargeIndex} style={{marginTop: '15px'}}>
                    <Col xs={1}>{recurringCharge.id > 0 ? recurringCharge.id : ''}</Col>
                    <Col xs={2}>{recurringCharge.name}</Col>
                    <Col xs={2}>{recurringCharge.amount}</Col>
                    <Col xs={2}>{this.renderPercentCheckbox(recurringCharge.percentage)}</Col>
                    <Col xs={2}>{this.renderOrderTypeField(orderTypeValue)}</Col>
                    <Col xs={2}>{this.renderTenderTypeField(paymentTypeValue)}</Col>
                    <Col xs={1} style={{ display: 'flex', justifyContent: 'center', paddingRight: '0px' }}>{this.renderEditButton(recurringCharge, recurringChargeIndex)}</Col>
                </Row>
            )
        }) : null
    }

    renderRecurringCharges() {
        const { saveBtn, headerStyle } = this.props.styles;
        
        return (
            <Row xs={12} style={{margin: '20px 30px'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', marginBottom: '10px'}}>
                    <p style={{...headerStyle, marginBottom: '0px'}}>{i18n.t('screens:paymentScreen.recurringCharges')}</p>
                    <div style={{position: 'relative'}}>
                        <Button disabled={this.props.isMenuuAdmin} color="primary" style={{ display: 'flex' }} onClick={() => this.toggleModal()}>
                            <span style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="add_circle_outline" color="#fff" size={18} /></span>
                            <span style={saveBtn}>{i18n.t('screens:paymentScreen.addRecurringCharge')}</span>
                        </Button>
                        {this.state.toSaveReccuringCharges ? this.renderSaveReminder(true) : null}
                    </div>
                </div>
                <Col style={{ padding: '0px 0px 5px 0px', marginTop: '20px', textAlign: 'center' }}>
                    <Row>
                        <Col xs={1}>{i18n.t('screens:paymentScreen.id')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.name')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.amount')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.percent')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.orderType')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.paymentType')}</Col>
                    </Row>
                {this.renderRecurringChargesFormRows()}
                </Col>
            </Row>
        )
    }

    renderSaveButton() {
        const { saveBtn } = this.props.styles;

        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '70px'}}>
                 <Button 
                 color="primary" 
                 style={{ display: 'flex' }} 
                 onClick={() => this.onSaveSubscription()}
                 disabled={this.props.isMenuuAdmin}
                 >
                    <span className="saveIcon" style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="save" color="#fff" size={18} /></span>
                    <span style={saveBtn}>{i18n.t('common:buttons.save')}</span>
                </Button>
            </div>
        )
    }

    render() {
        
        return (
            <div>
                {this.renderHeader()}
                {this.renderFixedPriceRate()}
                {this.renderFixedPricePerOrder()}
                {this.renderPercentFromOrderTotal()}
                {this.renderSmsFee()}
                {this.renderTaxPercent()}
                {this.renderRecurringCharges()}
                {this.renderSaveButton()}
                { this.state.isRecurringModalOpen ? 
                    <RecurringModal
                    {...this.props}
                    isOpen={this.state.isRecurringModalOpen}
                    toggle={this.toggleModal}
                    currentRecurringCharge={this.state.currentRecurringCharge}
                    applyCurrentRecurringCharge={this.applyCurrentRecurringCharge}
                    renderTenderTypeOptions={this.renderTenderTypeOptions}
                    negativeDecimalsValidation={this.negativeDecimalsValidation}
                    recurringChargeIndex={this.state.recurringChargeIndex}
                     /> : null
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        orderTypes: state.orderTypes,
        serviceSettingsGeneral: state.serviceSettingsGeneral,
        tenderTypes: state.tenderTypes,
        restaurant: state.restaurant,
    }
}

export default connect(mapStateToProps, { 
    getCurrencySymbol,
    loadOrderTypes,
    saveSubscription,
    getSubscription
     })(Subscription);

const styles = {

    cardContainer: {
        // width: '70%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '15px',
        marginRight: '0px',
        paddingBottom: '10px'
        // margin: '0px 15px 0'
    },
    cardContainerWithError: {
        // width: '70%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '15px',
        marginRight: '0px',
        paddingBottom: '0px'
        // margin: '0px 15px 0'
    },
    btnStyle: {
        display: 'flex',
        alignSelf: 'center',
        padding: '0px 6px 3px'
    },
    reminderText: {
        color: '#dc3545',
        width: '120px',
        fontSize: 13,
        position: 'absolute',
        right: '0px',
        //top: '52px'
    },
    cardContainerNotes: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0px 15px 15px 15px',
        marginRight: '0px'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/menuuBilling/Subscription.js